import { useContext, useEffect, useMemo } from "react";

import {
  PaginationContext,
  SortContext,
  InventoryTable,
  InventorySectionContext,
} from "dash-ui";
import {
  PropertyFragment,
  PropertyTransactionTypesEnum,
  useGetUnitsQuery,
} from "gql/generated.graphql";

function InventoryTableSection({
  filter,
  allowDownloads,
}: {
  filter: { property: PropertyFragment };
  allowDownloads?: boolean;
}) {
  const {
    _id: propertyId,
    defaultInventoryDetails,
    transactionType,
  } = filter.property;

  const {
    setTotal,
    state: paginationState,
    getRefetchProps,
  } = useContext(PaginationContext);
  const { state: sort } = useContext(SortContext);
  const { activeTab } = useContext(InventorySectionContext);

  const { skip, limit } = getRefetchProps(paginationState);

  const sortQuery = sort.fieldName ? [sort] : undefined;

  const { data: result, loading } = useGetUnitsQuery({
    variables: {
      sort: sortQuery,
      pagination: { skip, limit },
      filter: { propertyId, inventoryType: activeTab },
    },
  });

  const { data, total } = useMemo(
    () => ({
      data: result?.getUnits?.collection || [],
      total: result?.getUnits?.totalCount || 0,
    }),
    [result]
  );

  useEffect(() => {
    setTotal(total);
  }, [total]);

  const isRent = useMemo(
    () => transactionType === PropertyTransactionTypesEnum.ForRent,
    [transactionType]
  );

  return (
    <InventoryTable
      data={data}
      loading={loading}
      emptyStateText={defaultInventoryDetails || ""}
      isPortfolioView={true}
      allowDownloads={allowDownloads}
      isRent={isRent}
    />
  );
}

export default InventoryTableSection;
